export default __webpack_public_path__ + "static/media/favoritesIcon.0a0e836b.svg";